import { venueZoneAbbreviation } from '@wineryxplorer/shared';
import { formatDisplayTime } from '../../lib/timeFormat';

interface OperatingHoursProps {
  hours?: Record<string, { open?: string; close?: string; closed?: boolean }>;
  notes?: string;
  validated?: boolean;
  /** IANA zone the hours are written in; omitted for venues not yet backfilled. */
  timezone?: string | null;
}

export const OperatingHours = ({ hours, notes, validated, timezone }: OperatingHoursProps) => {
  if (!hours) return null;

  const dayOrder = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

  const formatHours = () => {
    return Object.entries(hours)
      .sort(([a], [b]) => dayOrder.indexOf(a) - dayOrder.indexOf(b))
      .map(([day, dayHours]) => (
        <div key={day} className="flex justify-between py-1">
          <span className="capitalize font-medium">{day}</span>
          <span>
            {dayHours.closed
              ? 'Closed'
              : `${formatDisplayTime(dayHours.open)} - ${formatDisplayTime(dayHours.close)}`}
          </span>
        </div>
      ));
  };

  const zone = venueZoneAbbreviation(timezone);

  return (
    <div>
      <h2 className="text-xl font-semibold text-gray-900 mb-2">
        Hours{zone ? <span className="text-gray-500 text-base font-normal"> · {zone}</span> : null}
      </h2>
      <div className="text-gray-700 space-y-1">
        {formatHours()}
      </div>
      {notes && (
        <p className="text-gray-600 text-sm mt-2 italic">{notes}</p>
      )}
      {validated === false && (
        <p className="text-gray-500 text-sm mt-2">
          Hours not yet verified — please call ahead.
        </p>
      )}
    </div>
  );
};